// extracted by mini-css-extract-plugin
export var barContainer = "_2k-0";
export var extraThin = "_2k-3";
export var fillBar = "_2k-6";
export var fillContainer = "_2k-4";
export var overflow = "_2k-8";
export var overflowContainer = "_2k-5";
export var regular = "_2k-7";
export var thick = "_2k-1";
export var thin = "_2k-2";